import connectToStores from "alt-utils/lib/connectToStores";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router";

import ChatListItem from "./ChatListItem";
import Loader from "./Loader";

import AskFormStore from "../../stores/chat/AskFormStore";
import ChatActions from "../../actions/ChatActions";
import ChatListStore from "../../stores/chat/ChatListStore";
import ConfigStore from "../../stores/chat/ConfigStore";

import heartbeat from "../../utils/chat/chatHeartbeat";
import { history } from "../../utils/chat/chatNavigation";

const heartbeatConfig = {
    onAuthFail: () => {
        history.push("/minimized");
        ChatActions.resetAuth();
    },
    onLoad: ChatActions.list,
    onSuccess: ChatActions.listSuccess,
    onError: ChatActions.listFail,
};

class ChatListView extends Component {
    componentWillMount() {
        ChatActions.resetChat();
    }

    componentDidMount() {
        const { configId, contactInfoWasPrefilled } = this.props;

        this.props.heartbeat.query({
            emailPrefilled: contactInfoWasPrefilled,
            cfgId: configId,
        });
        this.props.heartbeat.start();
    }

    componentWillUnmount() {
        this.props.heartbeat.stop();
    }

    static getStores() {
        return [AskFormStore, ChatListStore, ConfigStore];
    }

    static getPropsFromStores() {
        return {
            closedChatList: ChatListStore.getState().closedChatList,
            configId: ConfigStore.getConfig().id,
            contactInfoWasPrefilled: AskFormStore.contactInfoWasPrefilled(),
            disableAskNewQuestionFromUi: ConfigStore.getConfig().disableAskNewQuestionFromUi,
            isLoading: ChatListStore.getState().isLoading,
            openChatList: ChatListStore.getState().openChatList,
        };
    }

    render() {
        const { closedChatList, disableAskNewQuestionFromUi, isLoading, openChatList } = this.props;

        return (
            <Loader isLoading={isLoading}>
                <div className="chat-list-view-container">
                    <div className="chat-list-container">
                        {openChatList.length > 0 ? (
                            <div className="open-chat-list">
                                <h2 className="question-bar">{i18n.t("rtm.text.active_conversations")}</h2>
                                <ul>
                                    {/*
                                        TODO: Refactor backend controller method so
                                        we don't have to 'chat.chat' :)
                                    */}
                                    {openChatList.map(({ chat }) => (
                                        <ChatListItem chat={chat} key={chat.question.uuid} />
                                    ))}
                                </ul>
                            </div>
                        ) : null}

                        {!disableAskNewQuestionFromUi && (
                            <div className="ask-question-btn-container">
                                <Link to="ask" className="btn">
                                    {i18n.t("rtm.button.ask_a_new_question")}
                                </Link>
                            </div>
                        )}

                        {closedChatList.length > 0 ? (
                            <div className="closed-chat-list">
                                <h2 className="question-bar closed">
                                    {i18n.t("rtm.text.recently_closed_conversations")}
                                </h2>
                                <div className="closed-chat-list">
                                    <ul>
                                        {closedChatList.map(({ chat }) => (
                                            <ChatListItem chat={chat} key={chat.question.uuid} />
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </Loader>
        );
    }
}

ChatListView.defaultProps = {
    closedChatList: [],
    openChatList: [],
};

ChatListView.propTypes = {
    closedChatList: PropTypes.arrayOf(
        PropTypes.shape({
            chat: PropTypes.shape({
                lastUpdated: PropTypes.string.isRequired,
                question: PropTypes.shape({
                    body: PropTypes.string.isRequired,
                    company: PropTypes.string.isRequired,
                    dateClosed: PropTypes.string,
                    dateCreated: PropTypes.string.isRequired,
                    id: PropTypes.number.isRequired,
                    lastUpdated: PropTypes.string,
                    messages: PropTypes.arrayOf(PropTypes.shape({})),
                    metadata: PropTypes.arrayOf(PropTypes.shape({})),
                    numberOfResponses: PropTypes.number.isRequired,
                    response: PropTypes.arrayOf(PropTypes.shape({})),
                    subject: PropTypes.string.isRequired,
                    unreadMessageCount: PropTypes.number.isRequired,
                    uuid: PropTypes.string.isRequired,
                }),
            }),
        })
    ),
    configId: PropTypes.string.isRequired,
    contactInfoWasPrefilled: PropTypes.bool.isRequired,
    disableAskNewQuestionFromUi: PropTypes.bool.isRequired,
    heartbeat: PropTypes.shape({
        query: PropTypes.func,
        start: PropTypes.func.isRequired,
        stop: PropTypes.func.isRequired,
    }).isRequired,
    isLoading: PropTypes.bool.isRequired,
    openChatList: PropTypes.arrayOf(
        PropTypes.shape({
            chat: PropTypes.shape({
                lastUpdated: PropTypes.string.isRequired,
                question: PropTypes.shape({
                    body: PropTypes.string.isRequired,
                    company: PropTypes.string.isRequired,
                    dateClosed: PropTypes.string,
                    dateCreated: PropTypes.string.isRequired,
                    id: PropTypes.number.isRequired,
                    lastUpdated: PropTypes.string,
                    messages: PropTypes.arrayOf(PropTypes.shape({})),
                    metadata: PropTypes.arrayOf(PropTypes.shape({})),
                    numberOfResponses: PropTypes.number.isRequired,
                    response: PropTypes.arrayOf(PropTypes.shape({})),
                    subject: PropTypes.string.isRequired,
                    unreadMessageCount: PropTypes.number.isRequired,
                    uuid: PropTypes.string.isRequired,
                }),
            }),
        })
    ),
};

export default heartbeat("/chat/list", heartbeatConfig)(connectToStores(ChatListView));
